import { Col, Collapse, Row } from "antd";
import moment from "moment";
import React from "react";
import VideoCard from "./videoCard";
import "./view.scss";
const { Panel } = Collapse;

const ListVideoInstruction = ({ list = [], updateDeleteList = () => {},callBackAddPlayList=() => {} }) => {
  const renderListCard = (list) => {
    return list.map((i) => (
      <Col span={8}>
        <VideoCard
          title={i.title}
          author={i.displayName || i.createId}
          time={
            i.updateDatetime
              ? moment(i.updateDatetime).format("YYYY/MM/DD HH:mm:ss")
              : ""
          }
          description={i.videoExplanation}
          tag={i.tagLists || []}
          url={i.videoUrl || ""}
          videoId={i.id}
          updateDeleteList={updateDeleteList}
          machineList={i.machineNameLists}
          isEdit={i.isEdit}
          isDelete={i.isDelete}
          createTime={i.createDatetime}
          isVideoPlayList={i.isVideoPlayList}
          callBackAddPlayList={callBackAddPlayList}
          avatarUrl={i.avatarUrl}
        />
      </Col>
    ));
  };
  return (
    <Row
      style={{
        padding: 15,
      }}
      gutter={[16, 16]}
    >
      {renderListCard(list)}
    </Row>
  );
};

export default React.memo(ListVideoInstruction);
